import { Input } from "@/components/ui/input";
import { observer } from "mobx-react-lite";
import { Info } from "lucide-react";

interface VariableProps {
  variableName: string | undefined;
  onNameChange: (name: string) => void;
  isReadonly?: boolean;
  errors?: Record<string, string>;
}

const Variable = observer(
  ({
    variableName,
    onNameChange,
    isReadonly = false,
    errors,
  }: VariableProps) => {
    const hasVariableNameError = errors && errors.variableName;

    return (
      <div className="mb-4 ml-6 max-w-[500px] rounded-md border border-gray-200 bg-white p-4 shadow-sm">
        <div className="mb-2 text-sm font-medium text-gray-700">
          Variable name:
        </div>
        <div className="relative">
          <span className="absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-gray-400">
            {"{{"}
          </span>
          <Input
            type="text"
            value={variableName || ""}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="VariableName"
            className={`pl-8 pr-8 font-mono ${
              hasVariableNameError ? "border-red-500" : ""
            }`}
            readOnly={isReadonly}
          />
          <span className="absolute right-3 top-1/2 z-10 -translate-y-1/2 text-sm text-gray-400">
            {"}}"}
          </span>
        </div>
        {hasVariableNameError && (
          <div className="mt-1 text-xs text-red-500">
            {errors!.variableName}
          </div>
        )}
        <div className="mt-3 flex items-center gap-2 rounded-md bg-blue-50 p-2 text-xs text-blue-700">
          <Info className="h-4 w-4 flex-shrink-0" />
          <div>
            Use a valid JSON schema as the variable value during runtime
          </div>
        </div>
      </div>
    );
  },
);

export default Variable;
